import api from "../config/gatewayConfig";
import { verboseApiErrorsInTest } from "../config/featureConfig";

function truncate(value, maxLen = 400) {
  const text = String(value ?? "");
  if (text.length <= maxLen) {
    return text;
  }
  return `${text.slice(0, maxLen)}…`;
}

function extractBackendMessage(data) {
  if (data == null) {
    return null;
  }
  if (typeof data === "string") {
    return data.trim() || null;
  }
  if (typeof data === "object") {
    if (typeof data.message === "string" && data.message.trim()) {
      return data.message.trim();
    }
    if (typeof data.error === "string" && data.error.trim()) {
      return data.error.trim();
    }
  }
  return null;
}

export function formatAxiosErrorMessage(error) {
  const status = error?.response?.status;
  const backendError = error?.response?.data;
  const url = error?.config?.url;
  const method = error?.config?.method;
  const generic500 = "Si è verificato un problema, riprova più tardi.";

  if (!error?.response) {
    if (verboseApiErrorsInTest) {
      const base = api.apiBaseUrl ?? "gateway";
      return `Impossibile contattare il gateway (${base}). ${error?.message ?? "Errore di rete"}`;
    }
    return generic500;
  }

  if (status === 500 || status === 502 || status === 503 || status === 504) {
    if (!verboseApiErrorsInTest) {
      return generic500;
    }
    const backend = extractBackendMessage(backendError);
    const parts = [`Errore HTTP ${status}`];
    if (method && url) {
      parts.push(`${String(method).toUpperCase()} ${url}`);
    }
    if (backend) {
      parts.push(backend);
    }
    try {
      if (!backend && backendError != null) {
        parts.push(truncate(JSON.stringify(backendError)));
      }
    } catch {
      // ignore
    }
    return parts.join(" — ");
  }

  const backend = extractBackendMessage(backendError);
  if (backend) {
    return backend;
  }
  if (typeof backendError === "string") {
    return backendError;
  }
  if (backendError?.error) {
    return String(backendError.error);
  }
  if (error.message) {
    return error.message;
  }
  return "Si è verificato un problema imprevisto.";
}
